import styled from 'styled-components';
import { PlaceholderGroup, Stack, Text } from '@frameio/vapor';
import TEXT from './generated/TEXT/NoDirectMembers';

TEXT.DEFINE({
  /** Title shown when no direct members exist */
  title: 'No direct members',

  /** Description prompting user to add members */
  description: 'Add members to start collaborating',
});

export function NoDirectMembers({ shouldShow }: { shouldShow: boolean }) {
  if (!shouldShow) return null;
  return (
    <Wrapper>
      <PlaceholderGroup />
      <Stack alignX="center" gap={8}>
        <Text fontWeight="semiBold" variant="header">
          {TEXT.title}
        </Text>
        <Text color="tertiary" style={{ maxWidth: '160px' }} variant="body">
          {TEXT.description}
        </Text>
      </Stack>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  padding-block: 24px;
  text-align: center;
`;
